import { TFlex } from 'foundations-components/transitional/components/TFlex';
import PlaybooksPaginator from '../crm_ui/profile/sidebar/playbooks/PlaybooksPaginator';
import PlaybookList from './PlaybookList';
import PlaybooksSearchInput from './PlaybooksSearchInput';
import PlaybooksViewAllButton from './PlaybooksViewAllButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PlaybooksCardListView({
  state,
  actions,
  SuccessMarker,
  CardContentLoadingComponent
}) {
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "column",
    align: "stretch",
    "data-test-id": "playbook-card-list",
    "data-loading": state.loading,
    children: [!state.loading && SuccessMarker && /*#__PURE__*/_jsx(SuccessMarker, {}), state.loading && CardContentLoadingComponent && /*#__PURE__*/_jsx(CardContentLoadingComponent, {}), /*#__PURE__*/_jsxs(TFlex, {
      align: "stretch",
      direction: "column",
      children: [state.hasQueryOrResults && /*#__PURE__*/_jsx(PlaybooksSearchInput, {
        actions: actions
      }), state.showRecommendations && /*#__PURE__*/_jsx(PlaybookList, {
        isError: false,
        isLoading: state.loading,
        onClickPlaybook: actions.openPlaybookModal,
        result: state.recommendationResult,
        searchText: state.searchText
      }), state.showAllPlaybooks && /*#__PURE__*/_jsx(PlaybookList, {
        isError: state.failedToLoad,
        isLoading: state.loading,
        onClickPlaybook: actions.openPlaybookModal,
        result: state.playbooksResult,
        searchText: state.searchText
      })]
    }), state.showPaginator && /*#__PURE__*/_jsx(PlaybooksPaginator, {
      searchQuery: state.searchQuery,
      totalCount: state.totalPlaybooksCount,
      onPageChange: actions.handlePageChange
    }), !state.loading && !state.showAllPlaybooks && /*#__PURE__*/_jsx(PlaybooksViewAllButton, {
      actions: actions
    })]
  });
}